module.exports = __webpack_public_path__ + "media/images/menu/eridanus-752c42d5f8d4ee7762b7492c68a69e05.jpg";